import {
	AuditEventDTO,
	AuditEventRequest,
	AuditEventType,
	GetEventsForTicketsRequest,
	GetEventsForTicketsResponse,
} from 'core/api';

import { Bus, SessionProvider } from 'core/infrastructure';

const process = Bus.buildProcessFn('/bus/');

export async function audit(type: AuditEventType, action: string, eventDate: Date = new Date(), details = '', ticketGlobalId: Nullable<string> = null): Promise<void> {

	const config = Bus.getConfig();
	const session = SessionProvider.getCurrent();


	eventDate.setMilliseconds(0);

	const event: AuditEventDTO = {
		Action: action,
		ApplicationName: config.applicationName,
		Details: details,
		Id: 0,
		MachineName: 'Web Device',
		PosId: config.posId,
		PosName: session.PosName,
		TicketGlobalId: ticketGlobalId,
		ParentTicketGlobalId: null,
		Time: eventDate,
		Type: type,
		TypeDescription: AuditEventType.toString(type),
		UserId: session.UserId,
		UserName: session.UserName
	};
	const request = new AuditEventRequest({ event });
	return process(request);
}

export async function getEventsForTicket(ticketGlobalId: string): Promise<AuditEventDTO[]> {
	const request = new GetEventsForTicketsRequest({ ids: [ticketGlobalId] });
	return process(request, (response: GetEventsForTicketsResponse) => response.Events);
}
